import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {CircularProgressbar, buildStyles} from 'react-circular-progressbar';

import 'react-circular-progressbar/dist/styles.css';

class RecordButton extends PureComponent {
    state = { percentage: 0, showStop: false };
    timeout = null;
    interval = null;

    onContainerClick = () => {
        const { showStop, countdown } = this.state;
        const { onRecordClick, recording } = this.props;
        if ((!recording && !showStop) || (recording && showStop)) {
            onRecordClick();
        }
    }

    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.recording && this.props.recording) {
            this.interval = setInterval(() => {
                const { percentage } = this.state;
                if (percentage < 100) {
                    this.setState({percentage: percentage + 1 });
                } else {
                    this.setState({percentage: 0 })
                    clearInterval(this.interval);
                }
            }, this.props.maxLength * 10);
            
            this.timeout = setTimeout(() => {
                this.setState({showStop: true, countdown: false});
                clearTimeout(this.timeout);
            }, 10000)
        }
        if (prevProps.recording && !this.props.recording) {
            clearInterval(this.interval);
            this.setState({percentage: 0, showStop: false, countdown: false});
        }
    }
    
    componentWillUnmount() {
        clearTimeout(this.timeout);
        clearInterval(this.interval);
    }
    
    render() {
        const { recording } = this.props;
        const { percentage, showStop } = this.state;
    
        const buttonClasses = ['rec_button'];
        if (showStop) buttonClasses.push('stop');
        if (recording) buttonClasses.push('recording');

        return (
            <div className={recording ? "rec_container enabled" : "rec_container"} onClick={this.onContainerClick}>
                <CircularProgressbar
                    value={percentage}
                    className="rec_progress"
                    styles={buildStyles({
                        pathColor: '#ff8340',
                        trailColor: '#ffffff',
                    })}
                />
                <div className={buttonClasses.join(' ')} />
            </div>
        );
    }
}


RecordButton.propTypes = {
    recording: PropTypes.bool.isRequired,
    maxLength: PropTypes.number.isRequired,
    onRecordClick: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    maxLength: state.myVideoWindow.max_length
})

export default connect(mapStateToProps)(RecordButton);



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/VideoWindowMine/RecordButton.js